import { tableLayouts } from "@project/sharedcomponents/pdfmakeFunctions"

export const generatePdfDoc = (docDefinition) => {
  pdfMake.tableLayouts = tableLayouts
  // docDefinition.compress = true
  // docDefinition.displayTitle = "PDF"
  return pdfMake.createPdf(docDefinition)
}
